import { createSelector } from 'reselect';
import { KEY_GET_ORGANIZATIONS } from '../constants';
import { getDefaultOrganization } from '../helpers/getDefaultOrganization';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getOrganizationsState = (state: any) => state.requestStatus[KEY_GET_ORGANIZATIONS];

export const getCurrentOrganization = createSelector(getOrganizationsState, state => {
  const orgId = getDefaultOrganization(state?.response?.data)?.organizationId || '';
  return orgId;
});
